/* ============================================================
   DRAGON DEN — storefront interactions
   ============================================================ */
(function () {
  const money = (cents) => {
    const f = (window.DD && window.DD.moneyFormat) || "${{amount}}";
    const amt = (cents / 100).toFixed(2);
    return f.replace(/\{\{\s*amount\s*\}\}/g, amt).replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100));
  };

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    let t = $("#dd-toast");
    if (!t) {
      t = document.createElement("div");
      t.id = "dd-toast";
      t.className = "toast";
      document.body.appendChild(t);
    }
    t.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M20 6L9 17l-5-5"/></svg><span>' +
      msg +
      "</span>";
    requestAnimationFrame(() => t.classList.add("is-show"));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove("is-show"), 2600);
  }

  /* ---------- Cart drawer ---------- */
  const overlay = $("#cart-overlay");
  const drawer = $("#cart-drawer");
  const body = $("#drawer-body");
  const footEl = $("#drawer-foot");

  function openDrawer() {
    if (!drawer) return;
    overlay.classList.add("is-open");
    drawer.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }
  function closeDrawer() {
    if (!drawer) return;
    overlay.classList.remove("is-open");
    drawer.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  function renderCart(cart) {
    updateCount(cart.item_count);
    if (!body) return;
    if (!cart.items || cart.items.length === 0) {
      body.innerHTML =
        '<div class="drawer__empty"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 3h2l2.5 13.5a2 2 0 0 0 2 1.5h8a2 2 0 0 0 2-1.5L23 6H6"/><circle cx="10" cy="21" r="1"/><circle cx="18" cy="21" r="1"/></svg><p>Your den is empty.</p></div>';
      footEl.style.display = "none";
      return;
    }
    footEl.style.display = "block";
    body.innerHTML = cart.items
      .map(
        (it, i) => `
      <div class="line" data-key="${it.key}">
        <div class="line__img"><img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, "_120x$1$2") : ""}" alt="${it.product_title}"></div>
        <div class="line__main">
          <b>${it.product_title}</b>
          <div class="price">${money(it.final_price)}</div>
          <div class="qty">
            <button data-act="dec" data-key="${it.key}" aria-label="Decrease">−</button>
            <span>${it.quantity}</span>
            <button data-act="inc" data-key="${it.key}" aria-label="Increase">+</button>
          </div>
        </div>
        <button class="line__rm" data-act="rm" data-key="${it.key}">Remove</button>
      </div>`
      )
      .join("");
    footEl.querySelector("#drawer-subtotal").textContent = money(cart.total_price);
  }

  function updateCount(n) {
    $$(".cart-count").forEach((el) => {
      el.textContent = n;
      el.style.display = n > 0 ? "grid" : "none";
    });
  }

  async function getCart() {
    const r = await fetch("/cart.js");
    return r.json();
  }

  async function addToCart(id, qty = 1) {
    const r = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] }),
    });
    if (!r.ok) {
      const e = await r.json().catch(() => ({}));
      toast(e.description || "Could not add to cart");
      return;
    }
    const cart = await getCart();
    renderCart(cart);
    openDrawer();
  }

  async function changeLine(key, qty) {
    const r = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty }),
    });
    const cart = await r.json();
    renderCart(cart);
  }

  /* ---------- Event delegation ---------- */
  document.addEventListener("click", (e) => {
    const add = e.target.closest("[data-add-to-cart]");
    if (add) {
      e.preventDefault();
      const id = add.getAttribute("data-add-to-cart");
      if (!id) return;
      add.setAttribute("disabled", "");
      const label = add.querySelector("[data-label]") || add;
      const prev = label.textContent;
      label.textContent = "Summoning…";
      addToCart(id, 1).finally(() => {
        add.removeAttribute("disabled");
        label.textContent = prev;
      });
      return;
    }
    if (e.target.closest("[data-open-cart]")) {
      e.preventDefault();
      getCart().then(renderCart).then(openDrawer);
      return;
    }
    if (e.target.closest("[data-close-cart]") || e.target === overlay) {
      closeDrawer();
      return;
    }
    const act = e.target.closest("[data-act]");
    if (act) {
      const key = act.getAttribute("data-key");
      const a = act.getAttribute("data-act");
      const lineEl = act.closest(".line");
      const q = lineEl ? parseInt(lineEl.querySelector(".qty span").textContent, 10) : 1;
      if (a === "inc") changeLine(key, q + 1);
      if (a === "dec") changeLine(key, Math.max(0, q - 1));
      if (a === "rm") changeLine(key, 0);
      return;
    }
    // mobile menu
    if (e.target.closest("[data-open-menu]")) $("#mobile-menu")?.classList.add("is-open"), (document.body.style.overflow = "hidden");
    if (e.target.closest("[data-close-menu]")) $("#mobile-menu")?.classList.remove("is-open"), (document.body.style.overflow = "");
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") { closeDrawer(); $("#mobile-menu")?.classList.remove("is-open"); document.body.style.overflow=""; }
  });

  /* ---------- Product page form ---------- */
  const pform = $("#product-form");
  if (pform) {
    pform.addEventListener("submit", (e) => {
      e.preventDefault();
      const id = pform.querySelector('[name="id"]').value;
      const qty = parseInt(pform.querySelector('[name="quantity"]')?.value || "1", 10);
      const btn = pform.querySelector('[type="submit"]');
      const label = btn.querySelector("[data-label]") || btn;
      const prev = label.textContent;
      btn.setAttribute("disabled", "");
      label.textContent = "Summoning…";
      addToCart(id, qty).finally(() => {
        btn.removeAttribute("disabled");
        label.textContent = prev;
      });
    });
    // gallery thumbs
    const mainImg = $("#pdp-main-img");
    $$(".pdp__thumb").forEach((t) =>
      t.addEventListener("click", () => {
        $$(".pdp__thumb").forEach((x) => x.classList.remove("is-active"));
        t.classList.add("is-active");
        if (mainImg) mainImg.src = t.getAttribute("data-full");
      })
    );
  }

  /* ---------- Sticky mobile buy bar ---------- */
  const buybar = $("#buybar");
  const atcAnchor = $("#atc-anchor");
  if (buybar && atcAnchor) {
    const io = new IntersectionObserver(
      ([en]) => {
        if (window.innerWidth > 940) { buybar.classList.remove("is-show"); return; }
        buybar.classList.toggle("is-show", !en.isIntersecting);
      },
      { threshold: 0 }
    );
    io.observe(atcAnchor);
  }

  /* ---------- FAQ single-open (progressive) ---------- */
  $$(".faq details").forEach((d) =>
    d.addEventListener("toggle", () => {
      if (d.open) $$(".faq details").forEach((o) => { if (o !== d) o.open = false; });
    })
  );

  /* ---------- Scroll reveal ---------- */
  if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    const rev = new IntersectionObserver(
      (ents) => ents.forEach((en) => { if (en.isIntersecting) { en.target.style.opacity = 1; en.target.style.transform = "none"; rev.unobserve(en.target);} }),
      { threshold: 0.12 }
    );
    $$("[data-reveal]").forEach((el) => {
      el.style.opacity = 0;
      el.style.transform = "translateY(22px)";
      el.style.transition = "opacity .6s ease, transform .6s ease";
      rev.observe(el);
    });
  }

  // init count on load
  getCart().then((c) => updateCount(c.item_count)).catch(() => {});
})();
